/**
 * Click-to-open lightbox for custom-story-card.liquid's photo grid.
 * Unlike house-gallery-lightbox.js (built for exactly one gallery per
 * page), a Történetünk-style page stacks several story cards, each with
 * its own set of photos — every .story-card is wired up independently,
 * scoped to its own dialog and triggers, so opening one card's lightbox
 * never shows another card's photos.
 */

document.querySelectorAll('.story-card').forEach((card) => {
  const lightbox = card.querySelector('[data-gallery-lightbox]');
  const triggers = Array.from(card.querySelectorAll('[data-gallery-trigger]'));

  if (!lightbox || triggers.length === 0) return;

  const image = lightbox.querySelector('[data-gallery-image]');
  const counter = lightbox.querySelector('[data-gallery-counter]');
  let currentIndex = 0;

  function show(index) {
    currentIndex = (index + triggers.length) % triggers.length;
    const trigger = triggers[currentIndex];
    image.src = trigger.dataset.fullSrc;
    image.alt = trigger.dataset.alt || '';
    counter.textContent = `${currentIndex + 1} / ${triggers.length}`;
  }

  triggers.forEach((trigger, index) => {
    trigger.addEventListener('click', () => {
      show(index);
      lightbox.showModal();
    });
  });

  lightbox.querySelector('[data-gallery-close]').addEventListener('click', () => lightbox.close());
  lightbox.querySelector('[data-gallery-prev]').addEventListener('click', () => show(currentIndex - 1));
  lightbox.querySelector('[data-gallery-next]').addEventListener('click', () => show(currentIndex + 1));

  // Clicking the backdrop area closes the dialog — a click lands directly
  // on the <dialog> element itself only when it misses every child control.
  lightbox.addEventListener('click', (event) => {
    if (event.target === lightbox) lightbox.close();
  });

  lightbox.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowRight') show(currentIndex + 1);
    if (event.key === 'ArrowLeft') show(currentIndex - 1);
  });
});
